<template>
  <div class="ui-stat" :class="tone && `ui-stat--${tone}`">
    <span class="ui-stat__label">{{ label }}</span>
    <span class="ui-stat__value">{{ value }}<small v-if="unit"> {{ unit }}</small></span>
    <span v-if="bar !== null" class="ui-stat__bar"><i :style="{ width: `${Math.min(100, Math.max(0, bar))}%` }"></i></span>
    <slot></slot>
  </div>
</template>

<script>
/** Mala pločica sa podatkom (nije dugme). tone: accent | warn | inverse; unit se piše manje uz vrijednost; bar (0-100) crta traku napretka. */
export default {
  name: "UiStat",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: "" },
    unit: { type: String, default: "" },
    tone: { type: String, default: "" },
    bar: { type: Number, default: null },
  },
};
</script>
